import { useEffect, type ReactNode } from 'react';
import { notification } from 'antd';

import useFeatureFlag from '@/v2/domains/FeatureFlags/hooks/useFeatureFlag.hook';
import { FEATURE_FLAG_NAMES } from '@rockalingua/shared/featureFlags/constants';

import { notificationStyle } from './FloatingNotification.styled';

const notificationKey = 'floating-notification';

type FloatingNotificationProps = {
  visible: boolean;
  header: ReactNode;
  content: ReactNode;
};

export default function FloatingNotification({
  visible,
  header,
  content,
}: FloatingNotificationProps) {
  const [api, contextHolder] = notification.useNotification();
  const isEnabled = useFeatureFlag(FEATURE_FLAG_NAMES.FLOATING_SURVEYS);

  useEffect(() => {
    if (!visible || !isEnabled) {
      notification.close(notificationKey);
      return;
    }

    api.open({
      closeIcon: <></>,
      key: notificationKey,
      placement: 'bottomRight',
      duration: 0,
      message: header,
      description: content,
      style: notificationStyle,
    });

    return () => notification.close(notificationKey);
  }, [visible, isEnabled, header, content]);

  return contextHolder;
}
